import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ADD_ASSETS,
  DELETE_ASSETS,
  GET_ASSETS_BY_ID,
  LIST_ASSETS_MASTER,
} from "constants/url";
import { axiosPehalGigAdmin } from "services/api";

export const GetAllAsset = createAsyncThunk(
  `gigs/GetAllAsset`,
  async (thunkAPI) => {
    try {
      const response = await axiosPehalGigAdmin.get(`${LIST_ASSETS_MASTER}`);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const AddUpdateAsset = createAsyncThunk(
  `gigs/AddUpdateAsset`,
  async ({ payload, cb }, thunkAPI) => {
    try {
      const response = await axiosPehalGigAdmin.post(ADD_ASSETS, payload);
      cb(response);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const EditAsset = createAsyncThunk(
  `gigs/getUserDetailsById`,
  async (payload, thunkAPI) => {
    try {
      const response = await axiosPehalGigAdmin.get(
        `${GET_ASSETS_BY_ID}/${payload}`
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const DeleteAsset = createAsyncThunk(
  `gigs/DeleteAsset`,
  async (payload, thunkAPI) => {
    try {
      await axiosPehalGigAdmin.delete(`${DELETE_ASSETS}/${payload}`);
      return payload;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);
